<template>
  <nav aria-label="..." v-if="pages > 1">
    <ul class="pagination justify-content-center">
      <li v-for="(item, index) in new Array(pages)" class="page-item" :class="activeClass(index)"
          v-bind:key="index">
        <a class="page-link" @click="loadPage(index + 1)">{{ index + 1 }}</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    itemCount: Number,
    itemsPerPage: Number,
    useEventForLoadPage: {
      type: Boolean,
      default: false
    }
  },
  emits: [ "page-changed" ],
  data()
  {
    return {
      page: -1
    }
  },
  methods: {
    activeClass(index)
    {
      return this.page === index + 1 ? 'active' : 'inactive';
    },
    loadPage(page)
    {
      this.page = page;

      if (this.useEventForLoadPage)
      {
        this.$emit("page-changed", page);
      }
      else
      {
        let params = { ...this.$route.query };
        params.page = this.page;

        this.$router.push({ path: this.$route.path, query: params });
      }
    }
  },
  computed: {
    pages()
    {
      if (this.itemCount == null || this.itemsPerPage == null)
      {
        return 1;
      }

      return Math.ceil(this.itemCount / this.itemsPerPage);
    }
  },
  created()
  {
    this.page = parseInt(this.$route.query.page) || 1;
  }
}
</script>

<style lang="scss" scoped>
.pagination
{
  gap: 10px;
}

.page-link
{
  border: none;
  color: $font-grey;

  cursor: pointer;

  background-color: transparent;
}

.page-item.active
{
  .page-link
  {
    font-weight: 500;
    background-color: transparent;
    color: $font-dark;
  }
}
</style>